module.exports = __webpack_public_path__ + "img/bg-4.44e89ada.jpg";